import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Request } from '../../models/request';
import { APIService } from '../../services/http/http.service';
import { createApiUrl } from '../../utils/functions';
import { CollectionResponse } from '../../utils/types';
import { RequestConsent } from './consents/request-consent.type';

@Injectable()
export class RequestService extends APIService<Request> {
  route = 'request';

  getRequestConsents(params: {
    ProjectId: number;
    ApartmentId: number;
    ClientId: number;
    page: number;
    limit: number;
  }): Promise<CollectionResponse<RequestConsent>> {
    const url = createApiUrl('request', 'consents');

    const optionsParams = {};

    if (params.ProjectId) {
      optionsParams['ProjectId'] = String(params.ProjectId);
    }

    if (params.ApartmentId) {
      optionsParams['ApartmentId'] = String(params.ApartmentId);
    }

    if (params.ClientId) {
      optionsParams['ClientId'] = String(params.ClientId);
    }

    if (params.page) {
      optionsParams['page'] = String(params.page);
    }

    if (params.limit) {
      optionsParams['limit'] = String(params.limit);
    }

    return firstValueFrom(
      this.http.get<CollectionResponse<RequestConsent>>(
        url,
        this.options({
          params: optionsParams,
        }),
      ),
    );
  }
}
